import { createColConsignmentLinks, createColOrderLinks } from '@/const/table/columns'
import { formatNum } from '@/utils/format/number'

// Описание таблиц КПП по типам (По партиями, по этапам, по позициям)
export const KPP_TYPES = [
  {
    value: 'consignment',
    name: 'По партиям',
    table: {
      classes: 'table-report--kpp-consignment',
      isSticky: true,
      columnsBefore: [
        {
          title: '№ счета',
          name: 'order_account_number',
          rowspan: 2
        },
        {
          title: '№ позиции',
          name: 'position_sort',
          rowspan: 2
        },
        {
          title: '№ партии',
          name: 'consignment_sort',
          rowspan: 2
        },
        {
          title: 'Кол-во изделий, шт.',
          name: 'value',
          sortable: true,
          sortDesc: true,
          rowspan: 2
        },
        {
          title: 'Этап',
          name: 'status_name',
          sortable: true,
          sortDesc: true,
          rowspan: 2
        },
        {
          title: 'Время ожидания, часы',
          colspan: 2
        },
        {
          title: 'Время выполнения, часы',
          colspan: 2
        },
        {
          title: 'Общее время, часы',
          colspan: 2
        }
      ],
      columns: [
        {
          title: '№ счета',
          name: 'order',
          ...createColOrderLinks(false)
        },
        {
          title: '№ позиции',
          name: 'position_sort',
          handlerTotal: () => {
            return '-'
          }
        },
        {
          title: '№ партии',
          name: 'consignment',
          hasIcons: true,
          icons: [
            {
              icon: {
                name: 'notification-error',
                class: 'svg-icon--notification-error svg-icon--red',
                height: '17px',
                width: '17px'
              },
              tooltipText: 'Внутренняя рекламация',
              handlerIsShow: (item) => {
                return !!item?.inner_reclamation_id
              }
            },
            {
              icon: {
                name: 'rollback',
                class: 'svg-icon--rollback svg-icon--orange',
                height: '24px',
                width: '24px'
              },
              tooltipText: 'Откат партии',
              handlerIsShow: (item) => {
                return !!item?.is_rollback
              }
            }
          ],
          handlerTotal: () => {
            return '-'
          },
          ...createColConsignmentLinks(false, 'id', 'sort')
        },
        {
          title: 'Кол-во изделий, шт.',
          name: 'value',
          handlerFormat: formatNum
        },
        {
          title: 'Этап',
          name: 'status_name',
          hasExtrasFieldsAfter: true
        },
        {
          title: 'Время на партию',
          name: 'time_at_wait',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 изделие',
          name: 'time_at_wait_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_at_wait / +totalItem.value
          }
        },
        {
          title: 'Время на партию',
          name: 'time_at_work',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 изделие',
          name: 'time_at_work_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_at_work / +totalItem.value
          }
        },
        {
          title: 'Время на партию',
          name: 'time_total',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 изделие',
          name: 'time_total_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_total / +totalItem.value
          }
        }
      ],
      handlerColumns: (cols) => cols.slice(5, cols.length)
    },

    excel: {
      handledFields: formatExcelFieldsTitleKpp,
      handlerRows: handlerRowsKppConsignment,
      handledAdditionalFieldsExcel: handledAdditionalFieldsExcelKpp
    }
  },
  {
    value: 'stage',
    name: 'По этапам',
    table: {
      classes: 'table-report--kpp-stage',
      isSticky: true,
      columnsBefore: [
        {
          title: 'Период',
          name: 'period',
          rowspan: 2
        },
        {
          title: 'Этап',
          name: 'status_name',
          sortable: true,
          sortDesc: true,
          rowspan: 2
        },
        {
          title: 'Кол-во изделий, шт.',
          name: 'value',
          sortable: true,
          sortDesc: true,
          rowspan: 2
        },
        {
          title: 'Время ожидания, часы',
          colspan: 2
        },
        {
          title: 'Время выполнения, часы',
          colspan: 2
        },
        {
          title: 'Общее время, часы',
          colspan: 2
        }
      ],
      columns: [
        {
          title: 'Период',
          name: 'period',
          isFullRows: true,
          handlerFormat: (item) => {
            return item || 'За весь период'
          }
        },
        {
          title: 'Этап',
          name: 'status_name'
        },
        {
          title: 'Кол-во изделий, шт.',
          name: 'value',
          handlerFormat: formatNum
        },
        {
          title: 'Время на все партии',
          name: 'time_at_wait',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 изделие',
          name: 'time_at_wait_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_at_wait / +totalItem.value
          }
        },
        {
          title: 'Время на все партии',
          name: 'time_at_work',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 изделие',
          name: 'time_at_work_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_at_work / +totalItem.value
          }
        },
        {
          title: 'Время на все партии',
          name: 'time_total',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 изделие',
          name: 'time_total_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_total / +totalItem.value
          }
        }
      ],
      handlerColumns: (cols) => cols.slice(3, cols.length)
    },
    excel: {
      handledFields: formatExcelFieldsTitleKpp,
      handlerRows: handlerRowsKppStage
    }
  },
  {
    value: 'position',
    name: 'Общий по позициям',
    table: {
      classes: 'table-report--kpp-position',
      isSticky: true,
      columnsBefore: [
        {
          title: 'Период',
          name: 'period',
          rowspan: 2
        },
        {
          title: 'Кол-во позиций, шт.',
          name: 'position_value',
          sortable: true,
          sortDesc: true,
          rowspan: 2
        },
        {
          title: 'Кол-во изделий, шт.',
          name: 'consignment_value',
          sortable: true,
          sortDesc: true,
          rowspan: 2
        },
        {
          title: 'Время ожидания, часы',
          colspan: 2
        },
        {
          title: 'Время выполнения, часы',
          colspan: 2
        },
        {
          title: 'Общее время, часы',
          colspan: 2
        }
      ],
      columns: [
        {
          title: 'Период',
          name: 'period',
          handlerFormat: (period) => {
            return period || 'За весь период'
          }
        },
        {
          title: 'Кол-во позиций, шт.',
          name: 'position_value',
          handlerFormat: formatNum
        },
        {
          title: 'Кол-во изделий, шт.',
          name: 'consignment_value',
          handlerFormat: formatNum
        },
        {
          title: 'Время на все позиции',
          name: 'time_at_wait',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 позицию',
          name: 'time_at_wait_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_at_wait / +totalItem.position_value
          }
        },
        {
          title: 'Время на все позиции',
          name: 'time_at_work',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 позицию',
          name: 'time_at_work_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_at_work / +totalItem.position_value
          }
        },
        {
          title: 'Время на все позиции',
          name: 'time_total',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum
        },
        {
          title: 'Ср. время на 1 позицию',
          name: 'time_total_by_one',
          sortable: true,
          sortDesc: true,
          handlerFormat: formatNum,
          handlerTotal: (items, name, totalItem) => {
            return +totalItem.time_total / +totalItem.position_value
          }
        }
      ],
      handlerColumns: (cols) => cols.slice(3, cols.length)
    },

    excel: {
      handledFields: formatExcelFieldsTitleKpp,
      handlerRows: handlerRowsKppPosition
    }
  }
]

// Форматирование полей шапки в эксель
function formatExcelFieldsTitleKpp (title, name) {
  if (name.includes('wait')) {
    return `${title} (ожид., ч.)`
  }
  if (name.includes('work')) {
    return `${title} (выпол., ч.)`
  }
  if (name.includes('total')) {
    return `${title} (общ., ч.)`
  }
  return title
}

// Перебор отчёта КПП по партиям для выгрузки в эксель (чтобы ссылки выводились корректно)
function handlerRowsKppConsignment (data) {
  return data.map(item => ({
    ...item,
    order: item.order?.account_number || '-',
    consignment: item.consignment?.sort || '-',
    ...numberFormatKppRows(item)
  }))
}

// Перебор отчёта КПП по этапам для выгрузки в эксель (чтобы период выводился корректно)
function handlerRowsKppStage (data) {
  return data.map((item, key) => ({
    ...item,
    period: key === 0 ? (item.period || 'За весь период') : '',
    ...numberFormatKppRows(item)
  }))
}

// Перебор отчёта КПП по позициям для выгрузки в эксель (чтобы период выводился корректно)
function handlerRowsKppPosition (data) {
  return data.map((item) => ({
    ...item,
    ...numberFormatKppRows(item)
  }))
}

// Форматирование числовых полей, чтобы в эксель файле выводились корректно
function numberFormatKppRows (item) {
  return {
    time_at_wait: formatNum(item.time_at_wait) || 0,
    time_at_wait_by_one: formatNum(item.time_at_wait_by_one) || 0,
    time_at_work: formatNum(item.time_at_work) || 0,
    time_at_work_by_one: formatNum(item.time_at_work_by_one) || 0,
    time_total: formatNum(item.time_total) || 0,
    time_total_by_one: formatNum(item.time_total_by_one) || 0
  }
}

// Добавление в выгрузку отчёта КПП excel доп. полей из выбранных фильтров
function handledAdditionalFieldsExcelKpp (filters) {
  const fieldMapping = {
    spring_type: ['Тип пружины', 'position_spring_type_name'],
    shape: ['Вид пружины', 'position_shape_name'],
    order_type: ['Тип заказа', 'order_type_name'],
    workshop: ['Цех производства', 'position_workshop_name'],
    winding_method: ['Тип навивки', 'position_winding_method_name']
  }

  const resultFields = {}
  for (const filterKey in fieldMapping) {
    if (filters[filterKey]) {
      const [label, value] = fieldMapping[filterKey]
      resultFields[label] = value
    }
  }

  return resultFields
}
